import { render, staticRenderFns } from "./PaytenestidetailReportDetail.vue?vue&type=template&id=05655610"
import script from "./PaytenestidetailReportDetail.vue?vue&type=script&lang=js"
export * from "./PaytenestidetailReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports